import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GenaiService {

  private allowedBottlers: string[] = [];

  setAllowedBottlers(bottlers: string[]): void {
    this.allowedBottlers = bottlers || [];
  }

  isGenAiAllowed(bottlerId: string | undefined | null): boolean {
    if (!bottlerId) return false;
    return this.allowedBottlers.includes(bottlerId);
  }
}
